function TyreFilterGroup(properties, filters) {
  this.header = properties.header;
  this.inputType = properties.inputType;
  this.name = properties.name;
  this.affectsCount = properties.affectsCount;
  this._filters = filters;

  this._filters.forEach((filter) => {
    filter.setGroup(this);
  });
}

Object.assign(TyreFilterGroup.prototype, {
  filters: function () {
    return this._filters;
  },

  setSource: function (source) {
    this.source = source;
  },

  tyres: function () {
    if (!this.source) return [];
    return this.source.tyres();
  },

  activeFilters: function () {
    return this._filters.filter((filter) => filter.isActive());
  },

  applyTo: function (tyres) {
    const activeFilters = this.activeFilters();
    if (activeFilters.length === 0) return tyres;

    return activeFilters.reduce((result, filter) => {
      return result.concat(filter.applyTo(tyres));
    }, []);
  },

  applyOthers: function () {
    return this.source.applyExcept(this);
  },

  deactivate: function () {
    this.activeFilters().forEach((filter) => filter.deactivate());
  },
});

export default TyreFilterGroup;
